import * as React from "react";
import { ApiKeyListItem } from "./ApiKeyListItem";
import { UpdateApiKeyFunction } from "../ApiKeyUpdater";
import { ApiKey } from "../../types";

// // // //

export function ApiKeyTable(props: {
    apiKeys: ApiKey[];
    loading: boolean;
    onUpdateApiKey: UpdateApiKeyFunction;
}) {
    const { apiKeys, loading, onUpdateApiKey } = props;
    return (
        <div
            className={
                loading
                    ? "flex flex-col transition-all duration-150 opacity-50"
                    : "flex flex-col transition-all duration-150"
            }
        >
            <div className="-my-2 sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="border rounded-sm overflow-hidden">
                        <table className="min-w-full divide-y">
                            <thead>
                                <tr className="bg-card text-slate-700 leading-normal select-none">
                                    <th
                                        scope="col"
                                        className="py-3 px-6 text-left font-normal text-slate-700"
                                    >
                                        Name
                                    </th>
                                    <th
                                        scope="col"
                                        className="py-3 px-6 text-left font-normal text-slate-700"
                                    >
                                        API Key
                                    </th>
                                    <th
                                        scope="col"
                                        className="hidden sm:table-cell py-3 px-6 text-left font-normal text-slate-700"
                                    >
                                        Created
                                    </th>
                                    <th
                                        scope="col"
                                        className="hidden sm:table-cell py-3 px-6 text-left font-normal text-slate-700"
                                    >
                                        Created By
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 hidden sm:table-cell"
                                    >
                                        <span className="sr-only">Actions</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {apiKeys.map((apiKey, index) => (
                                    <ApiKeyListItem
                                        key={apiKey.id}
                                        index={index}
                                        apiKey={apiKey}
                                        loading={loading}
                                        onUpdateApiKey={onUpdateApiKey}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
